<app-hero-section></app-hero-section>

@defer (on idle) {
  <app-landing-story></app-landing-story>
} @placeholder {
  <section class="min-h-[44rem] bg-surface px-4 py-24" aria-hidden="true">
    <div class="container mx-auto max-w-6xl animate-pulse space-y-8">
      <div class="h-4 w-40 rounded-full bg-surface-container-high"></div>
      <div class="h-14 max-w-xl rounded-2xl bg-surface-container"></div>
      <div class="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        @for (item of [1, 2, 3, 4]; track item) {
          <div class="h-48 rounded-2xl bg-surface-container"></div>
        }
      </div>
    </div>
  </section>
}
